module.exports = {
	"api": {
		"protocol": "https",
		"host": "api-spie.liftiq.app",
		"allowedOrigins": [
			"https://spie.liftiq.app"
		],
		"version": "v1",
		"remoteApi": "https://spie.liftiq.nl",
		"url": "https://api-spie.liftiq.app/api/v1"
	},
	"gmaps": {
		"key": "AIzaSyCmoAFnejYPQzPsrGy-d4s1yC7FAn6HBrg"
	},
	"website_name": "LiftIQ",
	"company_name": "LiftIQ",
	"company_phonenumber": "015 - 256 6666",
	"company_contact_page_url": "https://www.assetiq.nl/",
	"company_support_email": "support@dlr.nl",
	"no_reply_email": "no-reply@dlr.nl",
	"browser_theme_color": "#F2EDE2",
	"nav_background_color_primary": "#f2ede2",
	"nav_background_color_secondary": "#115571",
	"nav_button_text_color": "#000000",
	"nav_button_hover_color_primary": "#e53527",
	"nav_button_hover_color_secondary": "#e53527",
	"nav_button_hover_text_color": "#ffffff",
	"nav_border_color": "#000000",
	"public_path_logo": "/frontend/collabry/logo.png",
	"public_path_pdf_logo": null,
	"public_path_apple_touch_icon": "/frontend/collabry/apple-touch-icon.png",
	"public_path_favicon_icon_32x32": "/frontend/collabry/favicon-32x32.png",
	"public_path_favicon_icon_16x16": "/frontend/collabry/favicon-16x16.png",
	"public_path_mask_icon": "/frontend/collabry/safari-pinned-tab.svg",
	"public_path_manifest": "/frontend/collabry/manifest.json",
	"public_path_browserconfig": "/frontend/collabry/browserconfig.xml",
	"public_path_favicon": "/frontend/collabry/favicon.ico",
	"mjob_table_head_background_color": "#0f1e5a",
	"mjob_table_head_text_color": "#ffffff",
	"translation_label_mjob_nen": "custom_report_mmbp_pdf_nen",
	"translation_label_mjob_created_by": "custom_report_mmbp_pdf_created_by",
	"translation_label_mjob_disclaimer": "custom_report_mmbp_pdf_disclaimer",
	"footer_company_link_url": "http://assetiq.nl",
	"footer_company_link_text": "LiftIQ",
	"app_short_brand_name": "strukton",
	"app_long_brand_name": "LiftIQ",
	"app_name": "liftiq.app",
	"app_extranet_name": "LiftIQ",
	"app_navbar_color": "#482684",
	"app_favicon": "/:download/config_file?config_file_key=favicon",
	"app_logo": "/:download/config_file?config_file_key=logo",
	"app_icon": "/:download/config_file?config_file_key=apple_touch_icon",
	"widget_tooltip_icon_color": "#24429b",
	"widget_tooltip_box_color": "#505050",
	"excel_header_color": "#002060",
	"excel_background_color": "#DCE6F1",
	"public_path_excel_logo": null,
	"font_face_file": "/frontend/liftiq/DidactGothic-Regular",
	"logo_text_color": "#115571",
	"connect_url": "https://spie.liftiq.app",
	"app_inspection_legend": "/:download/config_file?config_file_key=inspection_legend",
	"portal_url": null,
	"iir_url": null,
	"login_color_main": "#217496"
}